module.exports = __webpack_public_path__ + "media/src/assets/images/booking-details/room_type-5d431e41b6b7799a313909ea412465a8.png";